import { apiService } from "./apiService";
import { endpoints } from "@/config/endpoints";
import { mockPlanRestrictions } from "@/enums/plan-restrictions";

export default {
  registerWithEmailAndPassword(data) {
    return apiService.post(endpoints.users.register, data);
  },

  loginWithEmailAndPassword(data) {
    return apiService.post(endpoints.users.login, data);
  },
  logout() {
    return apiService.post(endpoints.users.logout, {});
  },

  acceptInvitation({ email, ...data }) {
    return apiService.post(endpoints.acceptInvitation, data);
  },

  resendInvitation(userId) {
    return apiService.post(endpoints.resendInvitation, { user: userId });
  },

  changePassword(data) {
    return apiService.post(endpoints.users.changePassword, data);
  },

  resetPassword(data) {
    return apiService.post(endpoints.users.reset, data);
  },

  confirmResetPassword(data) {
    return apiService.post(endpoints.users.confirmReset, data);
  },

  getUserDetails() {
    return apiService.get(endpoints.users.me);
  },

  patchUserDetails(data) {
    return apiService.patch(endpoints.users.me, data);
  },

  postSubscriptionVoucher(payload) {
    return apiService.post(endpoints.subscriptionVouchers, {
      number: payload
    });
  },

  getGoogleOAuthAccounts() {
    return apiService.get(endpoints.googleOAuth);
  },

  postGoogleOAuthAccounts(token) {
    return apiService.post(endpoints.googleOAuth, { code: token });
  },

  postGoogleProfile(id, payload, params = {}) {
    return apiService.post(
      `${endpoints.gmbProfilePlaces}${id}/places/`,
      payload,
      { params }
    );
  },

  getLocationsImportStatus() {
    return apiService.get(endpoints.gmbLocationImports);
  },

  getGoogleProfilePlaces(id) {
    return apiService.get(`${endpoints.gmbProfilePlaces}${id}/`);
  },

  deleteGoogleProfile(id) {
    return apiService.delete(`${endpoints.gmbProfilePlaces}${id}/`);
  },

  deleteGoogleAccount(id) {
    return apiService.delete(`${endpoints.googleOAuth}${id}/`);
  },

  deleteGoogleProfilePlaces(place_id, payload) {
    return apiService.delete(
      `${endpoints.gmbProfilePlaces}${place_id}/places/`,
      { data: payload }
    );
  },

  getGoogleInsights(payload, params) {
    const xlsxExport = params && params.file_type == "xlsx";
    return apiService.post(endpoints.gmbInsights, payload, {
      params,
      ...(xlsxExport && { responseType: "blob" })
    });
  },
  getGoogleInsightsOld(payload, params) {
    return apiService.post(endpoints.gmbInsightsOld, payload, { params });
  },
  getGoogleInsightsAsync(payload, params) {
    return apiService.post(endpoints.gmbInsightsExport, payload, { params });
  }
};
